import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import axios from "axios";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import $ from "jquery";

import PROMO_A from "../../../assets/images/promo-a.png";
import PROMO_New from "../../../assets/images/promo-a-new.png";

import PROMO_B from "../../../assets/images/promo-b.png";
import PROMO_C from "../../../assets/images/promo-c.png";

import {
  COMPANY_NAME,
  LOGO,
  THEME_COLOR,
  APP_LIVE_URL,
  APP_URL,
  FOOTER_SIGNATURE,
} from "../../../config/config";

import { ValidateEmail, axiosConfig } from "../../../config/utility";
import ReCAPTCHA from "react-google-recaptcha";
import { jwtDecode } from "jwt-decode";

import helpherClass from "../../../config/helperClass";
import localization from "../../../localization/enUS";
import { GoogleLogin } from "@react-oauth/google";

const auth = new helpherClass();

export default class Login extends Component {
  constructor() {
    super();
    this.state = {
      errorEmail: "",
      errorPass: "",
      email: "",
      password: "",
      errorMessage: "",
      disabled: false,
      loader: "",
      successMessage: "",
      google_login: true,
      allowed_domain: false,
      google_allowed_domains: [],
      appVersion: "",
    };
    this.site_key = process.env.REACT_APP_CAPTCHA_SITE_KEY;
    this.captcha_token = null;
  }

  async componentDidMount() {
    // Fetch version from version.json
    try {
      const versionResponse = await fetch(`/version.json?ts=${Date.now()}`);
      const versionData = await versionResponse.json();
      if (versionData.version) {
        this.setState({ appVersion: versionData.version });
      }
    } catch (error) {
      this.setState({ appVersion: "Version info is temporarily unavailable" });
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}resellers/get_reseller_logo`,
        JSON.stringify({
          token: process.env.REACT_APP_API_TOKEN,
          api_accountno: process.env.REACT_APP_API_ACCOUNTNO,
        }),
        axiosConfig
      );

      if (
        response.data.status === 200 &&
        response.data.message === "success" &&
        response.data.data &&
        response.data.data.length > 0
      ) {
        // Encrypt and store the logo in cookies
        Cookies.set(
          "userlogo__",
          CryptoJS.AES.encrypt(
            response.data.data[0].user_logo, // Access user_logo within data array
            process.env.REACT_APP_SIGNATURE
          ).toString()
        );
        const google_login_flag =
          response.data.custom_settings?.[0]?.google_login === "Yes";
        const allowed_domain_flag =
          response.data.custom_settings?.[0]?.allowed_domain === "Yes";
        const google_allowed_domains =
          response.data.google_allowed_domains || [];
        this.setState({
          google_login: google_login_flag,
          allowed_domain: allowed_domain_flag,
          google_allowed_domains,
        });
      } else {
        // Handle specific error cases
        this.setState({});
      }
    } catch (error) {
      // console.log("Error fetching logo:", error);
      this.setState({});
    }
  }

  getUserLogo() {
    if (
      Cookies.get("userlogo__") == null ||
      Cookies.get("userlogo__") === undefined ||
      Cookies.get("userlogo__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("userlogo__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var userlogo__ = secByte.toString(CryptoJS.enc.Utf8);

      if (userlogo__ == "") {
        return false;
      } else {
        return userlogo__;
      }
    }
  }

  handleChange = (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  };
  handleCaptchaChange = (value) => {
    this.captcha_token = value;
  };

  formSubmit = (e) => {
    e.preventDefault();
    let { email, password } = this.state;

    if (email === "") {
      return this.setState({
        errorEmail: "error",
        errorMessage: "Email is required.",
      });
    } else if (ValidateEmail(email) === false) {
      return this.setState({
        errorEmail: "error",
        errorMessage: "Invalid email format.",
      });
    } else if (password === "") {
      return this.setState({
        errorPass: "error",
        errorEmail: "",
        errorMessage: "Password is required.",
      });
    } else if (this.captcha_token === "" || this.captcha_token === null) {
      return this.setState({
        errorPass: "",
        errorEmail: "",
        errorMessage: "Invalid captcha, please retry.",
      });
    } else {
      this.setState({
        errorPass: "",
        errorEmail: "",
        errorMessage: "",
        disabled: true,
        loader: "show",
      });

      try {
        axios
          .post(
            process.env.REACT_APP_API_URL + "login",
            JSON.stringify({
              email: email,
              password: password,
              token: process.env.REACT_APP_API_TOKEN,
              api_accountno: process.env.REACT_APP_API_ACCOUNTNO,
            }),
            axiosConfig
          )
          .then((response) => {
            //console.log("Login: ",response);
            if (
              response.data.status === 404 ||
              response.data.status === 422 ||
              response.data.errors !== ""
            ) {
              this.setState({
                errorMessage: response.data.errors,
                disabled: false,
              });
            }

            if (
              response.data.status === 200 &&
              response.data.message === "success"
            ) {
              this.setState({
                successMessage:
                  "Please wait, redirecting you to the dashboard.",
                errorMessage: "",
              });

              const decodedToken = jwtDecode(response.data.token);
              const tokenExpiryTime = decodedToken.exp * 1000;
              const currentTime = new Date().getTime();

              Cookies.set(
                "tkn__",
                CryptoJS.AES.encrypt(
                  response.data.token,
                  process.env.REACT_APP_SIGNATURE
                ).toString()
              );
              Cookies.set(
                "acn__",
                CryptoJS.AES.encrypt(
                  response.data.accountno,
                  process.env.REACT_APP_SIGNATURE
                ).toString()
              );
              Cookies.set(
                "eml__",
                CryptoJS.AES.encrypt(
                  response.data.email,
                  process.env.REACT_APP_SIGNATURE
                ).toString()
              );
              Cookies.set(
                "comp_nme__",
                CryptoJS.AES.encrypt(
                  response.data.comp_name,
                  process.env.REACT_APP_SIGNATURE
                ).toString()
              );
              Cookies.set(
                "name__",
                CryptoJS.AES.encrypt(
                  response.data.name,
                  process.env.REACT_APP_SIGNATURE
                ).toString()
              );
              Cookies.set(
                "phone__",
                CryptoJS.AES.encrypt(
                  response.data.phone,
                  process.env.REACT_APP_SIGNATURE
                ).toString()
              );
              Cookies.set(
                "title__",
                CryptoJS.AES.encrypt(
                  response.data.title,
                  process.env.REACT_APP_SIGNATURE
                ).toString()
              );
              Cookies.set(
                "usertype__",
                CryptoJS.AES.encrypt(
                  response.data.user_type,
                  process.env.REACT_APP_SIGNATURE
                ).toString()
              );
              Cookies.set(
                "subpoenatype__",
                CryptoJS.AES.encrypt(
                  response.data.admin_type,
                  process.env.REACT_APP_SIGNATURE
                ).toString()
              );
              Cookies.set(
                "userlogo__",
                CryptoJS.AES.encrypt(
                  response.data.user_logo,
                  process.env.REACT_APP_SIGNATURE
                ).toString()
              );
              Cookies.set(
                "useracct__",
                CryptoJS.AES.encrypt(
                  response.data.user_accountno,
                  process.env.REACT_APP_SIGNATURE
                ).toString()
              );
              Cookies.set(
                "usertkn__",
                CryptoJS.AES.encrypt(
                  response.data.sub_user_token,
                  process.env.REACT_APP_SIGNATURE
                ).toString()
              );
              Cookies.set(
                "decimalPoint__",
                CryptoJS.AES.encrypt(
                  response.data.decimalPoint.toString(),
                  process.env.REACT_APP_SIGNATURE
                ).toString()
              );

              Cookies.set(
                "billing_decimalPoint__",
                CryptoJS.AES.encrypt(
                  response.data.billing_decimalPoint.toString(),
                  process.env.REACT_APP_SIGNATURE
                ).toString()
              );
              Cookies.set(
                "session_start__",
                CryptoJS.AES.encrypt(
                  currentTime.toString(),
                  process.env.REACT_APP_SIGNATURE
                ).toString()
              );
              Cookies.set(
                "session_expiry__",
                CryptoJS.AES.encrypt(
                  tokenExpiryTime.toString(),
                  process.env.REACT_APP_SIGNATURE
                ).toString()
              );
              localStorage.removeItem("activeMenus");
              localStorage.removeItem("activeSubmenuItem");
              if (
                response.data.admin_type &&
                response.data.admin_type === "Yes"
              ) {
                setTimeout(function () {
                  window.location.replace("/Compliance");
                }, 1000);
              } else {
                setTimeout(function () {
                  window.location.replace("/dashboard");
                }, 1000);
              }
            }
          });
      } catch (error) {
        // console.log("catch : ", error);
      }
    }
  };

  handleGoogleSuccess = (credentialResponse) => {
    if (
      process.env.REACT_APP_GOOGLE_OAUTH_CLIENTID ===
      credentialResponse.clientId
    ) {
      this.authLogin(credentialResponse.credential);
    }
  };

  authLogin = (authToken) => {
    let reseller_url = this.props.match.params.reseller_url;
    this.setState({
      disabled: true,
    });
    try {
      axios
        .post(
          process.env.REACT_APP_API_URL + "login_Oauth",
          JSON.stringify({
            token: process.env.REACT_APP_API_TOKEN,
            api_accountno: process.env.REACT_APP_API_ACCOUNTNO,
            authToken: authToken,
            reseller_url: reseller_url,
          }),
          axiosConfig
        )
        .then((response) => {
          // console.log("response: ", response);
          if (response.data.status === 403) {
            this.setState({
              errorMessage: response.data.message || "Unauthorized domain.",
              successMessage: "",
              disabled: false,
            });

            // Refresh page after short delay
            setTimeout(() => {
              window.location.reload();
            }, 2000);

            return;
          }
          if (response.data.status === 403) {
            this.setState({
              errorMessage: response.data.message || "Unauthorized domain.",
              successMessage: "",
              disabled: false,
            });
            return;
          }
          if (
            response.data.status === 404 &&
            response.data.message ===
              "OAuth login is only allowed for Sub users."
          ) {
            this.setState({
              errorMessage: "OAuth login is only allowed for Sub users.",
              successMessage: "",
              disabled: false,
            });
            return;
          }
          if (
            response.data.status === 200 &&
            response.data.message === "success" &&
            response.data.requestType === "user_register"
          ) {
            const userEmail = response.data.userEmail;
            const userName = response.data.userName;
            const userSub = response.data.userSub;
            const requestType = response.data.requestType;
            const signup_hash = response.data.signup_hash;
            const userComp = response.data.comp_name;
            const userPhone = response.data.phone;
            const userAdress = response.data.address;
            const userAdress2 = response.data.address2;
            const userState = response.data.state;
            const userCity = response.data.city;
            const userZip = response.data.zip;
            const userCountry = response.data.country;

            // console.log(
            //   "userEmail: ",
            //   userEmail,
            //   ", userName: ",
            //   userName,
            //   ", userSub: ",
            //   userSub,
            //   ", requestType: ",
            //   requestType
            // );
            localStorage.setItem("userEmail", userEmail);
            localStorage.setItem("userName", userName);
            localStorage.setItem("userSub", userSub);
            localStorage.setItem("userComp", userComp);
            localStorage.setItem("userPhone", userPhone);
            localStorage.setItem("userAdress", userAdress);
            localStorage.setItem("userAdress2", userAdress2);
            localStorage.setItem("userState", userState);
            localStorage.setItem("userCity", userCity);
            localStorage.setItem("userZip", userZip);
            localStorage.setItem("userCountry", userCountry);
            localStorage.setItem("authProvider", "google");
            this.setState({
              successMessage:
                "Please wait, while we set up your account. You will shortly be redirected to complete the setup process.",
              errorMessage: "",
            });
            setTimeout(() => {
              const redirectUrl = `sub_users/register/${signup_hash}`;
              window.location.replace(redirectUrl);
            }, 2000);
          } else if (
            response.data.status === 200 &&
            response.data.message === "Success_sso"
          ) {
            this.setState({
              successMessage: "Account registered successfully. Redirecting...",
              errorMessage: "",
            });

            setTimeout(() => {
              window.location.href = `${window.location.origin}/${response.data.redirect_url}`;
            }, 2000);
          } else if (
            response.data.status === 200 &&
            response.data.message === "success" &&
            response.data.requestType === "user_login"
          ) {
            this.setState({
              successMessage: "Please wait, redirecting you to the dashboard.",
              errorMessage: "",
            });

            const decodedToken = jwtDecode(response.data.token);
            const tokenExpiryTime = decodedToken.exp * 1000;
            const currentTime = new Date().getTime();

            Cookies.set(
              "tkn__",
              CryptoJS.AES.encrypt(
                response.data.token,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "acn__",
              CryptoJS.AES.encrypt(
                response.data.accountno,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "eml__",
              CryptoJS.AES.encrypt(
                response.data.email,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "comp_nme__",
              CryptoJS.AES.encrypt(
                response.data.comp_name,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "name__",
              CryptoJS.AES.encrypt(
                response.data.name,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "phone__",
              CryptoJS.AES.encrypt(
                response.data.phone,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "title__",
              CryptoJS.AES.encrypt(
                response.data.title,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "usertype__",
              CryptoJS.AES.encrypt(
                response.data.user_type,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "subpoenatype__",
              CryptoJS.AES.encrypt(
                response.data.admin_type,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "userlogo__",
              CryptoJS.AES.encrypt(
                response.data.user_logo,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "useracct__",
              CryptoJS.AES.encrypt(
                response.data.user_accountno,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "usertkn__",
              CryptoJS.AES.encrypt(
                response.data.sub_user_token,
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "decimalPoint__",
              CryptoJS.AES.encrypt(
                response.data.decimalPoint.toString(),
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "billing_decimalPoint__",
              CryptoJS.AES.encrypt(
                response.data.billing_decimalPoint.toString(),
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "session_start__",
              CryptoJS.AES.encrypt(
                currentTime.toString(),
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            Cookies.set(
              "session_expiry__",
              CryptoJS.AES.encrypt(
                tokenExpiryTime.toString(),
                process.env.REACT_APP_SIGNATURE
              ).toString()
            );
            localStorage.removeItem("activeMenus");
            localStorage.removeItem("activeSubmenuItem");
            if (
              response.data.admin_type &&
              response.data.admin_type === "Yes"
            ) {
              setTimeout(function () {
                window.location.replace("/Compliance");
              }, 1000);
            } else {
              setTimeout(function () {
                window.location.replace("/dashboard");
              }, 1000);
            }
          } else {
            this.setState({
              successMessage: "",
              errorMessage:
                "There was some error while processing the request. Please try again!",
            });
          }
        });
    } catch (error) {
      this.setState({
        errorMessage: "",
        successMessage: "",
        show_form: false,
        disabled: false,
        pageError:
          "Please enter the valid URL or contact admin for more details",
      });
      // console.log("catch : ", error);
    }
  };

  render() {
    if (auth.isLogin() === true) {
      return <Redirect to="/dashboard" />;
    }
    if (auth.isAdminLogin() === true) {
      return <Redirect to="/admin_dashboard" />;
    }
    return (
      <div className="nk-body npc-crypto ui-clean pg-auth">
        <div className="nk-app-root">
          {/* <div className="progress progress-sm">
            <div className="progress-bar" data-progress="95"></div>
          </div> */}
          <div className="nk-split nk-split-page nk-split-md">
            <div className="nk-split-content nk-block-area nk-block-area-column nk-auth-container">
              <div className="absolute-top-right d-lg-none p-3 p-sm-5">
                <a
                  href="#"
                  className="toggle btn-white btn btn-icon btn-light"
                  data-target="athPromo"
                >
                  <em className="icon ni ni-info"></em>
                </a>
              </div>
              <div
                className="nk-block nk-block-middle nk-auth-body"
                style={{ marginRight: "auto" }}
              >
                <div className="brand-logo pb-5  text-center">
                  <a href="/" className="logo-link">
                    <img
                      className="logo-light logo-img logo-img-lg"
                      src={
                        this.getUserLogo()
                          ? `${APP_LIVE_URL}files_data/logos/${this.getUserLogo()}`
                          : LOGO
                      }
                      alt="logo"
                    />
                    <img
                      className="logo-dark logo-img logo-img-lg"
                      src={
                        this.getUserLogo()
                          ? `${APP_LIVE_URL}files_data/logos/${this.getUserLogo()}`
                          : LOGO
                      }
                      alt="logo-dark"
                    />
                  </a>
                </div>
                {/*<div className="brand-logo pb-5">
                  <a href="/" className="logo-link">
                    <img
                      className="logo-light logo-img logo-img-lg"
                      src={LOGO}
                      alt="logo"
                    />
                    <img
                      className="logo-dark logo-img logo-img-lg"
                      src={LOGO}
                      alt="logo-dark"
                    />
                  </a>
                </div>*/}
                <div className="nk-block-head">
                  <div className="nk-block-head-content">
                    <h5 className="nk-block-title">
                      {localization.loginPage.label}
                    </h5>

                    <div className="nk-block-des">
                      <p>Use your verified email and password.</p>

                      {this.state.errorMessage !== "" ? (
                        <div className="example-alert">
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessage}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {this.state.successMessage !== "" ? (
                        <div className="example-alert">
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessage}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <br />
                      {/* <p
                        style={{
                          color: "red",
                          fontSize: "20px",
                          fontWeight: 600,
                        }}
                      >
                        {this.state.errorMessage}
                      </p> */}
                    </div>
                  </div>
                </div>
                <form
                  method="post"
                  className="loginForm"
                  onSubmit={this.formSubmit}
                >
                  <div className="form-group">
                    <div className="form-label-group">
                      <label className="form-label" htmlFor="default-01">
                        Email
                      </label>
                      {/* <a
                        className="link link-primary link-sm"
                        tabIndex="-1"
                        href="#"
                      >
                        Need Help?
                      </a> */}
                    </div>
                    <input
                      type="email"
                      className={
                        "form-control form-control-lg " + this.state.errorEmail
                      }
                      id="email"
                      name="email"
                      value={this.state.email}
                      onChange={this.handleChange}
                      placeholder="Enter your email address"
                     />
                  </div>
                  <div className="form-group">
                    <div className="form-label-group">
                      <label className="form-label" htmlFor="password">
                        Password
                      </label>
                      <a
                        className="link link-primary link-sm"
                        tabIndex="-1"
                        href="/forgot"
                        style={{ color: "#006393" }}
                      >
                        Forgot Password?
                      </a>
                    </div>
                    <div className="form-control-wrap">
                      <a
                        tabIndex="-1"
                        href="#"
                        className="form-icon form-icon-right passcode-switch"
                        data-target="password"
                      >
                        <em className="passcode-icon icon-show icon ni ni-eye"></em>
                        <em className="passcode-icon icon-hide icon ni ni-eye-off"></em>
                      </a>
                      <input
                        type="password"
                        className={
                          "form-control form-control-lg " + this.state.errorPass
                        }
                        id="password"
                        name="password"
                        onChange={this.handleChange}
                        value={this.state.password}
                        placeholder="Enter your password"
                       />
                    </div>
                  </div>
                  <ReCAPTCHA
                    sitekey={this.site_key}
                    onChange={this.handleCaptchaChange}
                    style={{ padding: "0px 0px 15px" }}
                  />
                  <div className="form-group">
                    <button
                      className="btn btn-lg btn-block"
                      disabled={this.state.disabled}
                      type="submit"
                      style={{ backgroundColor: THEME_COLOR, color: "white" }}
                    >
                      Sign in
                    </button>
                  </div>
                  {this.state.google_login &&
                    this.state.allowed_domain &&
                    this.state.google_allowed_domains.length > 0 && (
                      <>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "10px",
                            marginBottom: "10px",
                          }}
                        >
                          <hr
                            style={{
                              flex: 1,
                              border: "none",
                              borderBottom: "1px solid #ccc",
                            }}
                          />
                          <span style={{ padding: "0 10px" }}>OR</span>
                          <hr
                            style={{
                              flex: 1,
                              border: "none",
                              borderBottom: "1px solid #ccc",
                            }}
                          />
                        </div>
                        <div className="my-3">
                          <div className="googleLoginBtn-large">
                            <GoogleLogin
                              onSuccess={this.handleGoogleSuccess}
                              onError={() => {
                                // console.log("Login Failed");
                              }}
                              size="large"
                              theme="outline"
                              text="signup_with"
                              width="380px"
                              logo_alignment="center"
                            />
                          </div>
                          <div className="googleLoginBtn-small">
                            <GoogleLogin
                              onSuccess={this.handleGoogleSuccess}
                              onError={() => {
                                // console.log("Login Failed");
                              }}
                              size="large"
                              theme="outline"
                              text="signup_with"
                              width="335px"
                              logo_alignment="center"
                            />
                          </div>
                        </div>
                      </>
                    )}
                </form>
                <div className="form-note-s2 pt-4">
                  {" "}
                  {/*New on our platform? <a href="/register">Create an account</a>*/}
                </div>
              </div>
              <div
                className="nk-block nk-auth-footer"
                style={{ marginRight: "auto" }}
              >
                {/* <div className="nk-block-between">
                  <ul className="nav nav-sm">
                    <li className="nav-item">
                      <a className="nav-link" href="#">
                        Terms & Condition
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#">
                        Privacy Policy
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#">
                        Help
                      </a>
                    </li>
                  </ul>
                </div> */}
                <div className="text-center">
                  <p>{FOOTER_SIGNATURE}</p>
                  <div>
                    <a
                      href={`${APP_URL}pages/privacyPolicy`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-underline"
                    >
                      Privacy Policy
                    </a>
                    <span className="mx-2">|</span>
                    <a
                      href={`${APP_URL}pages/terms-of-service`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-underline"
                    >
                      Terms of Service
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="nk-split-content nk-split-stretch bg-lighter d-flex toggle-break-lg toggle-slide toggle-slide-right"
              data-content="athPromo"
              data-toggle-screen="lg"
              data-toggle-overlay="true"
            >
              <div className="slider-wrap w-100 w-max-550px p-3 p-sm-5 m-auto">
                <div
                  className="slider-init"
                  data-slick='{"dots":true, "arrows":false}'
                >
                  <div className="slider-item">
                    <div className="nk-feature nk-feature-center">
                      <div className="nk-feature-img">
                        <img className="round" src={PROMO_New} alt="" />
                      </div>
                      <div className="nk-feature-content py-4 p-sm-5">
                        <h4>{COMPANY_NAME}</h4>
                        <p>{localization.loginPage.description}</p>
                      </div>
                    </div>
                  </div>
                  {/* <div className="slider-item">
                    <div className="nk-feature nk-feature-center">
                      <div className="nk-feature-img">
                        <img className="round" src={PROMO_B} alt="" />
                      </div>
                      <div className="nk-feature-content py-4 p-sm-5">
                        <h4>{COMPANY_NAME}</h4>
                        <p>
                          You can start to create your products easily with its
                          user-friendly design & most completed responsive
                          layout.
                        </p>
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="slider-item">
                    <div className="nk-feature nk-feature-center">
                      <div className="nk-feature-img">
                        <img className="round" src={PROMO_C} alt="" />
                      </div>
                      <div className="nk-feature-content py-4 p-sm-5">
                        <h4>{COMPANY_NAME}</h4>
                        <p>
                          You can start to create your products easily with its
                          user-friendly design & most completed responsive
                          layout.
                        </p>
                      </div>
                    </div>
                  </div> */}
                </div>
                {/* <div className="slider-dots"></div>
                <div className="slider-arrows"></div> */}
                {this.state.appVersion && (
                  <div className="text-center mt-3">
                    <small style={{ color: "#8094ae" }}>
                      Version {this.state.appVersion}
                    </small>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
